import './styles.scss'
import PropTypes from 'prop-types'

const SearchField = function ({ placeholderText, onInput, onClear, value }) {
  return (
    <div className="search-field">
      <span className="search-icon"></span>
      <input
        value={value}
        onInput={onInput}
        placeholder={placeholderText}
        type="text"
      />
      {
        value && <span
          onClick={onClear}
          className="close-icon"
        />
      }
    </div>
  )
}

SearchField.propTypes = {
  placeholderText: PropTypes.string.isRequired,
  onInput: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}

export default SearchField
